# Giochi di Fibonacci 2025/2026

## Fase I - Scuole primarie

Questa prova contiene _6 problemi_ da risolvere in _50 minuti_, ed è divisa in due parti:
- quattro problemi di **pensiero logico-algoritmico**, e
- due problemi di interpretazione di **procedimenti procedurali** come programmi a blocchi.

In tutte e due le parti i problemi sono ordinati per difficoltà crescente.
**Fai attenzione, la difficoltà è soggettiva:** se stai passando tanto tempo cercando di risolvere un problema, prova a passare ad altri problemi e altre categorie.

**Attento!** Anche che se gareggi online, **non devi uscire dalla piattaforma di gara** per nessun motivo!

Puoi invece usare calcolatrici, fogli e materiale da cancelleria.

## Punteggio

Ogni problema comprende _due domande_, valutate separatamente.
La prima domanda è **sempre più semplice**, e può aiutare a rispondere alla seconda domanda.
Le domande sono tutte a **scelta multipla** con cinque opzioni. **Solo una è corretta.**
Il punteggio che puoi ottenere è:

- 5 punti per una risposta _corretta_;
- 1 punto per una risposta _non data_;
- 0 punti per una risposta _sbagliata_.
